import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import PageTitle from "../../molecules/PageTitle";
import DoorInfo from "./DoorInfo";
import DoorBasicSettings from "./DoorBasicSettings";
import DoorScheduleSettings from "./DoorScheduleSettings";
import { useParams } from "react-router-dom";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import { CustomContainer } from "../../../styles/styles";
import NavigateButton from "../../atoms/Button/NavigateButton";

export interface DoorData {
  autoSdcId: number;
  sdcUuid: string;
  sdcSerialNumber: string;
  doorPlace: string;
  isScheduleEnabled: boolean;
  startLock: string;
  endLock: string;
  building: {
    autoBuildingId: number;
    buildingName: string;
  };
}

const DoorSettingsPage = () => {
  const { autoBuildingId, autoSdcId } = useParams();
  const [doorData, setDoorData] = useState<DoorData | undefined>(undefined);

  // API呼び出しをここで行う
  useEffect(() => {
    // 内部の非同期関数を定義
    const fetchData = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();

      try {
        // call showSdcWithAutoBuildingId API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT +
          `/buildings/${autoBuildingId}/sdcs/${autoSdcId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: jwtToken,
            },
          },
        );

        const data = await response.json();
        setDoorData(data);
        console.log("API取得データ" + JSON.stringify(data));
      } catch (error) {
        console.error(error);
      }
    };

    // 非同期関数を実行
    fetchData();
  }, [autoBuildingId, autoSdcId]);

  return (
    <CustomContainer maxWidth="xl">
      <Grid item xs={12} marginBottom={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <PageTitle title="ドア詳細設定" />
          <NavigateButton
            to={"/buildings/" + autoBuildingId + "/doors"}
            buttonTitle={"管理ドア一覧"}
          />
        </Box>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={6}>
            <DoorInfo doorData={doorData} setDoorData={setDoorData} />{" "}
            {/* ドアデータを子コンポーネントに渡す */}
          </Grid>
          {/* <Grid item xs={12} md={6} marginTop={2}>
            <Grid container justifyContent="flex-end">
              <Button variant="outlined" color="primary" onClick={handleSave}>設定保存</Button>
            </Grid>
          </Grid> */}
          <Grid item xs={12} md={6} marginTop={4}>
            <DoorBasicSettings doorData={doorData} />{" "}
            {/* 手動開閉の解錠・開放ボタンを含むドアの基本設定 */}
          </Grid>
          <Grid item xs={12} md={6} marginTop={4}>
            <DoorScheduleSettings doorData={doorData} />{" "}
            {/* 施錠スケジュールの有効、無効のラジオボタンと時間設定セレクタを含むドアのスケジュール設定 */}
          </Grid>
        </Grid>
      </Grid>
    </CustomContainer>
  );
};

export default DoorSettingsPage;
